module.exports = __webpack_public_path__ + "img/9788962171877.966508fa.jpg";